import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-external-redirect',
    standalone: true,
    template: `
    <div style="padding: 2rem;">
      <section class="panel">
          <h3>Redirecting...</h3>
          <p>Please wait while redirecting to the external identity provider.</p>
      </section>
    </div>
  `,
    styles: [`
    :host { display: block; }
  `],
})
export class ExternalRedirectComponent implements OnInit {
    constructor(private route: ActivatedRoute) { }
    ngOnInit(): void {
        const externalUrl = this.route.snapshot.data['externalUrl'];
        if (typeof externalUrl === 'function') {
            window.location.href = externalUrl();
        } else if (externalUrl) {
            window.location.href = externalUrl;
        }
    }
}
